import { render, staticRenderFns } from "./veStuHygieneItemEdit.vue?vue&type=template&id=79462e50&scoped=true"
import script from "./veStuHygieneItemEdit.vue?vue&type=script&lang=js"
export * from "./veStuHygieneItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79462e50",
  null
  
)

export default component.exports